import type { IconProps } from "./icons";

export default function LogoIcon(props: IconProps) {
  /* ignore props for logo */
  return (
    <svg
      viewBox="0 0 1024 1024"
      fill="none"
      className={props.className}
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_201_8)">
        <rect width="1024" height="1024" fill="white" />
        <path d="M0 0H409.6L0 409.6V0Z" fill="#31CC3A" />
        <path d="M409.6 0H813L0 813V409.6L409.6 0Z" fill="#2FBE89" />
        <path d="M813 0H1024V205L211 1024H0V813L813 0Z" fill="#599EA1" />
        <path d="M1024 614.4V1024H614.4L1024 614.4Z" fill="#D93CEB" />
        <path
          d="M1024 614.5L616.5 1028H206.9L1024 204.8V614.5Z"
          fill="#8D75BF"
        />
        <path
          d="M237.867 451.559V679H147.803V451.559H64.5879V381.417H322.12V451.559H237.867ZM520.093 551.998C520.093 640.125 477.275 684.188 391.639 684.188C384.721 684.188 376.421 683.358 366.736 681.698C357.052 680.038 347.229 677.547 337.269 674.227V591.427C344.324 596.269 352.141 600.212 360.718 603.255C369.434 606.161 376.628 607.613 382.3 607.613C398.348 607.613 410.315 602.702 418.201 592.879C426.225 582.918 430.237 567.562 430.237 546.81V381.417H520.093V551.998ZM847.974 679V515.89C847.974 500.533 848.458 483.655 849.427 465.255L850.049 451.559H847.559C843.132 474.939 839.743 491.126 837.391 500.118L793.604 679H709.351L663.489 502.193C662.244 497.766 658.993 480.888 653.736 451.559H651.246C653.182 498.043 654.151 527.096 654.151 538.717V679H575.501V381.417H709.766L750.647 543.075C751.616 546.395 752.861 553.174 754.383 563.412C756.043 573.511 757.081 581.327 757.496 586.861H758.741C760.263 574.272 762.684 559.4 766.004 542.245L804.188 381.417H936.377V679H847.974Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_201_8">
          <rect width="1024" height="1024" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
